'use client';

import { JSX, PropsWithChildren } from 'react';

import { TooltipProvider } from '@videoblocks/design-system';

import { NavigationGuardProvider } from '../components/lib/NavigationGuardProvider';

export function Providers({ children }: PropsWithChildren): JSX.Element {
    return (
        <NavigationGuardProvider>
            <TooltipProvider>{children}</TooltipProvider>
        </NavigationGuardProvider>
    );
}
